document.addEventListener("DOMContentLoaded", function () {
  const counters = document.querySelectorAll(".homepage_icon_text h2");

  const runCounter = (counter) => {
    const target = parseInt(counter.innerText.replace(/\D/g, ""));
    let current = 0;
    const increment = Math.ceil(target / 100);

    const updateCounter = () => {
      current += increment;
      if (current >= target) {
        counter.innerText = target + "+";
      } else {
        counter.innerText = current + "+";
        requestAnimationFrame(updateCounter);
      }
    };

    updateCounter();
  };

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const h2s = entry.target.querySelectorAll("h2");
          h2s.forEach(h2 => {
            if (!h2.dataset.animated) {
              runCounter(h2);
              h2.dataset.animated = "true";
            }
          });
        }
      });
    },
    { threshold: 0.2 }
  );

  document.querySelectorAll(".homepage_icon_text").forEach(el => observer.observe(el));
});
